var Geolocation = (function() {
    function getLocation(options) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(options.success, options.error);
        } else {
            alert('Geolocation er ikke understøttet i din browser');
        }
    }
    function showPosition(postion) {

    }

    return {
        getLocation: getLocation
    }
})();
